import React from 'react';
import styled from 'styled-components';
import { smallMediaQuery } from '../Grid';
import Line from './Line';
import { LabelPosition as Position } from './Utils';

const textSeparationFromChartEdge = 10; // in px
const iconSeparationFromChartEdge = 30; // in px

const Text = styled.div`
  position: absolute;
  transform: translateX(-50%);
  text-transform: uppercase;
  color: #666;

  @media ${smallMediaQuery} {
    font-size: 0.5rem;
  }
`;
const iconSize = 30; // in px
const IconOuterContainer = styled.div`
  width: ${iconSize}px;
  height: ${iconSize}px;
  position: absolute;
  transform: translateX(-50%);
`;
const IconContainer = styled.div`
  svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  path,
  polygon,
  rect {
    fill: var(--fill);
  }
`;

interface Props {
  position: Position;
  chartHeight: number;
  tipX: number;
  tipY: number;
  label: string;
  svgString: string;
  color: string;
}

const SectorLabel = (props: Props) => {
  const {
    position, chartHeight,
    tipX, tipY, label, svgString, color,
  } = props;
  let textStyle: React.CSSProperties, iconStyle: React.CSSProperties;
  if (position === Position.Top) {
    textStyle = {
      bottom: `${chartHeight + textSeparationFromChartEdge}px`,
      left: `${tipX}px`,
    };
    iconStyle = {
      bottom: `${chartHeight + iconSeparationFromChartEdge}px`,
      left: `${tipX}px`,
    };
  } else {
    textStyle = {
      top: `${chartHeight + textSeparationFromChartEdge}px`,
      left: `${tipX}px`,
    };
    iconStyle = {
      top: `${chartHeight + iconSeparationFromChartEdge}px`,
      left: `${tipX}px`,
    };
  }
  return (
    <>
      <Line position={position} chartHeight={chartHeight} tipX={tipX} tipY={tipY}/>
      <Text style={textStyle}>{label}</Text>
      <IconOuterContainer style={iconStyle}>
        <IconContainer
          dangerouslySetInnerHTML={{__html: svgString}}
          style={{'--fill': color}}
        />
      </IconOuterContainer>
    </>
  );
};

export default SectorLabel;
